/**
 * SafeCommentRenderer Component
 * Safely renders comment content without using dangerouslySetInnerHTML
 */
import React, { useEffect, useRef } from 'react';
import { renderCommentContent } from './htmlUtils';

const SafeCommentRenderer = ({ content, mentionUsers = [] }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current && content) {
      try {
        // Clear previous content
        containerRef.current.innerHTML = '';
        
        // Get the safe HTML content
        const safeHtml = renderCommentContent(content, mentionUsers);
        
        // Set the content safely
        containerRef.current.innerHTML = safeHtml;
      } catch (error) {
        console.error('Error rendering comment content:', error);
        // Fallback to plain text
        containerRef.current.textContent = content;
      }
    }
  }, [content, mentionUsers]);

  return <div ref={containerRef} />;
};

export default SafeCommentRenderer;